var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCert = function SvgIconCert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-cert_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-cert_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M10 9.938 8.604 11c-.07.056-.142.056-.219 0-.076-.056-.1-.125-.072-.208l.541-1.73-1.437-1.124a.176.176 0 0 1-.063-.209c.028-.083.09-.125.188-.125H9.27l.541-1.708c.028-.083.09-.125.188-.125.097 0 .16.042.188.125l.541 1.708h1.73c.097 0 .16.042.187.125.028.083.007.153-.063.208l-1.437 1.125.541 1.73c.028.083.004.152-.072.208-.077.056-.15.056-.22 0L10 9.937ZM10 18l-3.604.792a.702.702 0 0 1-.636-.146.72.72 0 0 1-.28-.584v-4.895c-.598-.514-1.077-1.202-1.438-2.063A6.683 6.683 0 0 1 3.5 8.5c0-1.806.632-3.34 1.896-4.604C6.66 2.632 8.194 2 10 2s3.34.632 4.604 1.896C15.868 5.16 16.5 6.694 16.5 8.5c0 .889-.167 1.76-.5 2.615-.333.854-.833 1.545-1.5 2.072v4.876a.72.72 0 0 1-.281.583.703.703 0 0 1-.636.146L10 18Zm0-4.5c1.389 0 2.57-.486 3.542-1.458C14.514 11.069 15 9.889 15 8.5c0-1.389-.486-2.57-1.458-3.542C12.569 3.986 11.389 3.5 10 3.5c-1.389 0-2.57.486-3.542 1.458C5.486 5.931 5 7.111 5 8.5c0 1.389.486 2.57 1.458 3.542.973.972 2.153 1.458 3.542 1.458Zm-3.02 3.625 3.02-.667 3 .667V14.25c-.458.25-.941.438-1.448.563A6.46 6.46 0 0 1 10 15a6.954 6.954 0 0 1-1.563-.177c-.513-.118-1-.31-1.458-.573v2.875Z"
  }))));
};
export default SvgIconCert;